<template>
  <div class="divided-wrapper">
    <span class="title">주문</span>
    <div class="contents">
      <input :value="editable[firstName]"
             @input="editable[firstName] = $event.target.value"
             type="number">
      <span class="unit">시</span>
    </div>
      /
    <span class="title">취소</span>
    <div class="contents">
      <input :value="editable[lastName]"
             @input="editable[lastName] = $event.target.value"
             type="number">
      <span class="unit">시</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LayoutDividedInput',
  props: {
    value: {
      type: Object,
      isRequired: true,
    },
    firstName: {
      type: String,
      isRequired: true,
    },
    lastName: {
      type: String,
      isRequired: true,
    },
  },
  data() {
    return {
      editable: {
        [this.firstName]: this.value[this.firstName],
        [this.lastName]: this.value[this.lastName],
      },
    };
  },
  created() {
    this.$watch(`editable.${this.firstName}`, () => {
      this.$emit('input', this.editable);
    });

    this.$watch(`editable.${this.lastName}`, () => {
      this.$emit('input', this.editable);
    });
  },
};

</script>

<style lang='scss' scoped>
.divided-wrapper {
  width: 300px;
  border: rgba(180, 180, 180, 0.4) 1px solid;
  border-radius: 5px;
  height: 40px;
  color: rgba(180, 180, 180, 0.8);

  display: flex;
  justify-content: space-around;
  align-content: center;
  align-items: center;

  .title {
    width: 40px;
  }

  .contents {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    align-content: center;

    .unit {
      width: 24px;
      margin-left: 4px;
    }

    input {
      color: rgba(0, 0, 0, 0.87);
      margin: 0 4px;
      border: none;
      width: 40px;
      text-align: right;

      &:focus {
        outline: none;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/LayoutDividedInput.vue